// extracted by mini-css-extract-plugin
export default {"container":"RS-z","leftColumn":"SS-z","rightColumn":"TS-z","item":"US-z"};